export interface SelectedProductActivityWebEntity {
    activityName: string
    activityId: string
}
  